const users = {
  users: {
    pageHeader: 'Usuarios',
    addNewUser: '+ Añadir nuevo usuario',
    name: 'Nombre',
    role: 'Rol',
    company: 'Compañía',
    status: 'Condición',
    noUser: '** Sin usuarios disponibles **',
    emailMatch: 'Introduce el mismo valor de nuevo.',
    validEmail: 'Introduce una dirección de correo electrónico válida.',
    fieldRequired: 'Este campo es obligatorio.',
    userFormHeader: 'Añadir nuevos usuarios',
    userProfile: 'Perfil de usuario',
    defaultEmailHelpText:
      'Se enviará un correo electrónico a esta dirección con explicaciones acerca de cómo iniciar sesión.',
    active: 'Activa',
    email: 'Correo electrónico',
    confirmEmail: 'Confirmar correo electrónico',
    firstName: 'Nombre',
    lastName: 'Apellido',
    phoneNumber: 'Número de teléfono',
    preferredLocale: 'Lugar preferido',
    units: 'Unidades',
    addUser: 'Añadir usuario',
    updateUser: 'Actualizar usuario',
    supportTechnician: 'Técnico de soporte',
    profileAdministrator: 'Administrador de perfiles',
    profileApprover: 'Aprobador de perfiles',
    administrator: 'Administrador',
    user: 'Usuario',
    viewOnly: 'Ver solamente',
    demonstration: 'Demostración',
    errorMessageLengthPhone: 'Se permite un máximo de 50 caracteres',
    all: 'Todos',
    inactive: 'Inactivo',
    termsAndServices: 'Solo el propietario del sistema puede proporcionar acceso a su sitio. Sin la aprobación por escrito del propietario del sistema, los instaladores no pueden proporcionar acceso a otras compañías y no pueden proporcionar acceso a usuarios fuera de su compañía. He leído y acepto los %{termsService} de Enphase y he leído la %{privacyPolicy} de Enphase. Comprendo que el incumplimiento de estas condiciones puede resultar en la suspensión o cancelación de mi cuenta de Enlighten.',
    privacyPolicy: 'Política de privacidad',
    termsService: 'Términos de servicio'
  }
};

export default users;
